/**
 * Project: Academy V2
 * File: ClassReportRequestLayout.tsx
 * Author: Colopi Salvatore
 * Author URI: https://salvatorecolopi.com
 * Created: Wed Jul 10 2024 at 19:08:15
 *
 * Copyright (c) 2024 Edusogno. All rights reserved.
 */

import { Outlet } from "react-router-dom";

export default function ClassReportRequestLayout() {
  return <Outlet />;
}
